import { render, staticRenderFns } from "./UserCardBasic.vue?vue&type=template&id=e4be59e6"
import script from "./UserCardBasic.vue?vue&type=script&lang=js"
export * from "./UserCardBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports